"use client";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { removeCookie } from "helpers/cookies";
import { getCookie } from "helpers/cookies";
import { getDeviceUuid } from "helpers/guest";
import { addJobViewService } from "store/services/jobs/addJobView";
import {
  JOB_VIEW_BURIED_COOKIE,
  getDeviceNameTracker,
  viewJobSourceTracker
} from "components/ReportTracker/util";

type pagePropsType = {
  jobId?: number;
};

const Search = ({ jobId }: pagePropsType) => {
  const token = getCookie("sessionid");
  const viewJobTracker = getCookie(JOB_VIEW_BURIED_COOKIE);
  const searchParams = useSearchParams();
  let shared_from = searchParams.get("shared_from");
  shared_from = (shared_from || "").trim();

  useEffect(() => {
    if (jobId) {
      handleFetchAddJobViewService();
      addJobViewFromSharedService();
    }
  }, [jobId]);

  // add job view from shared url params
  const addJobViewFromSharedService = async () => {
    try {
      if (!shared_from) return;
      const query = {
        jobId,
        status: "public"
      };

      if (token) {
        query.status = token ? "protected" : "public";
      }
      const { reco_from, query_id } = viewJobTracker || {};
      const deviceUuid = await getDeviceUuid();
      const tokenData = {
        source: shared_from,
        device: getDeviceNameTracker(true),
        reco_from: reco_from ? reco_from : null,
        device_udid: deviceUuid,
        is_login: token ? 1 : 0,
        query_id: query_id || null
      };
      if (!tokenData.reco_from) {
        delete tokenData.reco_from;
      }

      const params = Object.assign(query, tokenData);

      addJobViewService(params).finally(() => {
        removeCookie(JOB_VIEW_BURIED_COOKIE);
      });
    } catch (error) {}
  };

  const handleFetchAddJobViewService = async () => {
    try {
      if (!viewJobTracker) return;
      const query = {
        jobId,
        status: "public"
      };

      if (token) {
        query.status = token ? "protected" : "public";
      }
      let _source = "";
      const { source, reco_from, query_id } = viewJobTracker || {};
      const deviceUuid = await getDeviceUuid();
      const normalSource = searchParams.get("source") || source || viewJobSourceTracker.jobsHiring;
      const hackquest = searchParams.get("apply_url");
      _source = hackquest ? `${hackquest}-${normalSource}` : normalSource;

      const tokenData = {
        source: _source,
        device: getDeviceNameTracker(true),
        reco_from: reco_from ? reco_from : null,
        device_udid: deviceUuid,
        is_login: token ? 1 : 0,
        query_id: query_id || null
      };
      if (!tokenData.reco_from) {
        delete tokenData.reco_from;
      }

      const params = Object.assign(query, tokenData);

      addJobViewService(params).finally(() => {
        removeCookie(JOB_VIEW_BURIED_COOKIE);
      });
    } catch (error) {}
  };
  return <></>;
};

export default Search;
